import { Swiper, SwiperSlide } from "swiper/react";
import { useContextHook } from "../../Context/ContextOPen";
import { Container } from "../../Tools/Grid-system";
import Speed from "../../images/OIP (1).jpg";
import Blog from "../../images/OIP.jpg";
import R from "../../images/R.jpg";
import idea from "../../images/idea-idea-with-light-bulbs-blue-background_167862-89.avif";
import logo from "../../images/logo.png";
import technology from "../../images/technology.jpg";
const Features = () => {
  const { swiperIndex, content, direction } = useContextHook();
  const dataFeatures = [
    {
      image: Speed,
      name: content.Speed,
      description: content.SpeedDescription,
    },
    {
      image: R,
      name: content.AnalyzeIdeas,
      description: content.AnalyzeIdeasDescription,
    },
    {
      image: Blog,
      name: content.Regularity,
      description: content.RegularityDescription,
    },
    {
      image: technology,
      name: content.ExclusiveDesigns,
      description: content.ExclusiveDesignsDescription,
    },
    {
      image: idea,
      name: content.Innovation,
      description: content.InnovationDescription,
    },
  ];
  return (
    <div className="">
      <Container>
        <h1
          style={{ direction: direction }}
          className={`text-5xl max-lg:text-4xl font-bold mb-5 logo first-letter:text-Main transition-all ${
            swiperIndex === 3 ? "hero" : ""
          }`}
        >
          {content.Features}
        </h1>
      </Container>
      <div className="">
        <Swiper
          className="min-h-[60vh] "
          spaceBetween={20}
          pagination={{ clickable: true }}
          breakpoints={{
            1150: {
              slidesPerView: 4.2,
            },
            992: {
              slidesPerView: 3.1,
            },
            768: {
              slidesPerView: 3,
            },
            420: {
              slidesPerView: 2,
            },
            0: {
              slidesPerView: 1.1,
            },
          }}
        >
          <SwiperSlide className="py-2 min-h-[60vh]  !flex justify-center items-center  ">
            <img src={logo} alt="" className=" " />
          </SwiperSlide>
          {dataFeatures.map((e, i) => (
            <SwiperSlide key={i} className="py-2">
              <CardFeature
                image={e.image}
                name={e.name}
                description={e.description}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Features;

const CardFeature = ({ image, name, description }) => {
  return (
    <>
      <div className="!h-full w-full text-center brabusShadow overflow-hidden rounded-xl ">
        <img src={image} alt="" className="w-full h-[200px]" />
        <h1 className="my-1 text-xl text-Main transition-all">{name}</h1>
        <p className="text-sm leading-6 max-xxl:leading-5 max-md:leading-6 pb-3 px-2">
          {description}
        </p>
      </div>
    </>
  );
};
